export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-rewind-d99d2054ca67bef660086dee7a055fc2.svg";